import React, { Component }   from 'react';
import { connect }            from 'react-redux';
import {Redirect}             from 'react-router'
import TimelineTurmaPostForm  from './timeline_turma_post_form';
import TurmaPostItem          from './turma_post_item';
import TurmaAlunosLista       from './turma_alunos_lista';
import FlashCarregando        from '../../../container/FlashCarregando';
import { GetRegistroPostTurma,
         IdTurmaProfessor}    from '../../../actions/turmaAction';
import {GetListaMenuTopo,
        GetListaSubMenuTopo}  from '../../../actions/scopoAction';
import { SetError }           from '../../../actions/notificacaoAction';

class Turma_Professor_Selecao extends Component {

    constructor(props){
        super(props);
        this.state    = { 
                          select_turma : "",
                          tur_id       : this.props.match.params.id,
                          carregando   : "Carregando...",
                          status       : false,
                          load         : false,
                          loadForm     : false,
                          loadAluno    : false,
                          post_item    : <TurmaPostItem/>
        }   
       
    }

    
    componentWillMount() {
        this.props.GetListaMenuTopo([
            {action:true,nome:"Home",link:this.props.menu.home},
            {action:true,nome:"Comunicação",link:this.props.menu.equipe.professor.home},
            {action:false,nome:"Timeline"},
        ]);
        this.props.GetListaSubMenuTopo([]);

        this.setState({ load : false,loadAluno : false });  
        this.props.GetRegistroPostTurma(this.props.session.id, this.state.tur_id).then((response) => {
             
           if(!response.payload.data){
               alert("O seu usuário, não foi encontrado em nenhuma Turma. Entre em contato com o seu professor, para maiores informações.");
               this.setState({routerPage:true})
           }else{
               this.props.IdTurmaProfessor(this.props.id);
               this.setState({ 
                               load         : true,
                               loadForm     : true,
                               loadAluno    : true,
                               tur_id       : this.state.tur_id,
                               select_turma : this.state.tur_id
                           });  
           }
  
       }).catch((error) => {
         this.props.SetError(500);

       });


    }    

    onChange(e){
       e.preventDefault();
       this.setState({status : (e.target.value ? true : false),select_turma: (e.target.value ? true : false)}); 
      if (e.target.value) {
           this.setState({tur_id:e.target.value}) 
          this.GetRegistroPosts(e.target.value);  
      }           
    }

    // GetRegistroPosts(id){

    //      this.setState({ load : false,loadAluno : false });  
    //      this.props.GetRegistroPostTurma(this.props.session.id, id).then((response) => {
              
    //         if(!response.payload.data){
    //             alert("O seu usuário, não foi encontrado em nenhuma Turma. Entre em contato com o seu professor, para maiores informações.");
    //             this.setState({routerPage:true})
    //         }else{
    //             this.props.IdTurmaProfessor(id);
    //             this.setState({ 
    //                             load         : true,
    //                             loadForm     : true,
    //                             loadAluno    : true,
    //                             tur_id       : id,
    //                             select_turma : id
    //                         });  
    //         }
   
    //     }).catch((error) => {
    //       this.props.SetError(500);

    //     });
    // }    

    render() {

        if (this.state.routerPage) {
            return (<Redirect to={'/home'}/>);
        }     

        return (<div>
                            <div className="row">
                                <div className="col-md-8">
                                    <ul className="timeline">
                                        <li className="timeline-inverted">
                                            <br/>
                                            {this.state.load?
                                        <ol className="breadcrumb">
                                            <li className="active"><b>{this.props.curso.cur_nome}</b></li>
                                            <li className="active"><b>{this.props.turma.tur_nome}</b></li>
                                        </ol>:""}
                                          {!this.state.loadForm ? <FlashCarregando/> : <TimelineTurmaPostForm tur_id={this.state.tur_id}/>}
                                        </li>
                                        <li className="timeline-inverted">
                                            {/* <button className='btn btn-primary btn-xs btn-block' onClick={this.GetRegistroPosts.bind(this,this.state.tur_id)}>Clique aqui para cerregar</button> */}
                                        </li>
                                    </ul>
                                    {!this.state.load ? <FlashCarregando/> :  <TurmaPostItem  tur_id={this.state.tur_id}/> }
                                </div>
                                <div className="col-md-4">
                                <br/>
                                    {!this.state.loadAluno ? <FlashCarregando/> :  <TurmaAlunosLista tur_id={this.state.tur_id}/>}
                                </div>
                            </div>
                        {/* </div>
                       :
                      ""
                    } */}
                </div>);
    }
}


function mapStateToProps(state){

    return {
        session        : state.auth.session,
        menu           : state.configReducer.menu,
        curso          : state.turmaReducer.curso,
        turma          : state.turmaReducer.turma,
        professorTurma : state.turmaReducer.allProfessorTurma
       
    }
}

export default connect(mapStateToProps,{
                                         GetRegistroPostTurma,
                                         GetListaMenuTopo,
                                         GetListaSubMenuTopo,
                                         IdTurmaProfessor,
                                         SetError
                                       })(Turma_Professor_Selecao);



// WEBPACK FOOTER //
// ./src/components/professor/timeline_turma/timeline_turma.js